import { createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-1" };
const _hoisted_2 = {
    key: 0,
    class: "text-sm text-foreground leading-none"
};
const _hoisted_3 = {
    key: 0,
    class: "text-xs text-destructive"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
            class: _normalizeClass(["flex items-center gap-2 cursor-pointer select-none", { 'cursor-not-allowed opacity-50': $props.isDisabled || $props.disabled }])
        }, [
            _createVNode($setup["Checkbox"], {
                id: $props.id ?? $props.staticId ?? undefined,
                "model-value": $setup.checkboxModelValue,
                disabled: $props.isDisabled || $props.disabled,
                "data-static-id": $props.id ?? $props.staticId ?? undefined,
                "onUpdate:modelValue": $setup.onChange,
                onBlur: $setup.onBlur
            }, null, 8 /* PROPS */, ["id", "model-value", "disabled", "data-static-id"]),
            ($props.label || _ctx.$slots.default)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        _createTextVNode(_toDisplayString($props.label), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($setup.errorMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
    ]));
}
